export default "__VITE_ASSET__Cx5Qjk8h__"